module.exports = __webpack_public_path__ + "img/servier.50789655.png";